module.exports = __webpack_public_path__ + "img/sone_ai.6eff46d1.png";